const EMAIL_VERIFICATION_TOAST =
  'Please verify your email before continuing. Check your inbox for the verification link.';

export const RESEND_VERIFICATION_THROTTLE_TOAST =
  'Please wait 5 minutes before requesting another verification email.';

const FRIENDLY_ERROR_MESSAGES = [
  {
    test: /email verification required/i,
    text: EMAIL_VERIFICATION_TOAST,
  },
  {
    test: /invalid verification token/i,
    text: 'This verification link is invalid or has already been used. Log in and request a new verification email.',
  },
  {
    test: /verification token expired/i,
    text: 'This verification link has expired. Log in and request a new verification email.',
  },
  {
    test: /throttler|too many requests/i,
    text: "You're doing that too often. Please wait a few minutes and try again.",
  },
];

const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

const parseJsonMessage = (value) => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (
    !(trimmed.startsWith('{') && trimmed.endsWith('}')) &&
    !(trimmed.startsWith('[') && trimmed.endsWith(']'))
  ) {
    return null;
  }
  try {
    return JSON.parse(trimmed);
  } catch {
    return null;
  }
};

const extractRawMessage = (input, depth = 0) => {
  if (input == null || depth > 4) return '';

  if (typeof input === 'string') {
    const parsed = parseJsonMessage(input);
    if (parsed != null) {
      return extractRawMessage(parsed, depth + 1);
    }
    return input.trim();
  }

  if (Array.isArray(input)) {
    return input.map((item) => extractRawMessage(item, depth + 1)).filter(Boolean).join('. ');
  }

  if (typeof input !== 'object') {
    return String(input);
  }

  if (input.response?.data != null) {
    const fromResponse = extractRawMessage(input.response.data, depth + 1);
    if (fromResponse) return fromResponse;
  }

  if (input.message != null && input.message !== input) {
    const fromMessage = extractRawMessage(input.message, depth + 1);
    if (fromMessage) return fromMessage;
  }

  if (typeof input.error === 'string' && input.error && input.error !== 'Forbidden') {
    return input.error;
  }

  return '';
};

export const isEmailVerificationMessage = (message) =>
  /email verification required/i.test(String(message || ''));

const mapFriendlyMessage = (raw) => {
  const match = FRIENDLY_ERROR_MESSAGES.find(({ test }) => test.test(raw));
  return match?.text || raw;
};

export const getFriendlyErrorMessage = (input, fallback = 'Something went wrong. Please try again.') => {
  const raw = extractRawMessage(input);
  return mapFriendlyMessage(raw) || fallback;
};

export const normalizeToastMessage = (message) => {
  if (message == null) return '';

  if (typeof message === 'string') {
    return getFriendlyErrorMessage(message, message);
  }

  if (isPlainObject(message) || Array.isArray(message) || message instanceof Error) {
    return getFriendlyErrorMessage(message);
  }

  return String(message);
};
